import api from './api';

/**
 * Site Popup Service (Admin Panel)
 * مدیریت پاپ‌آپ‌های سراسری سایت
 */

export interface PopupSlide {
  image?: string;
  imageAlt?: string;
  title?: string;
  subtitle?: string;
  description?: string;
  ctaText?: string;
  ctaLink?: string;
  ctaOpenInNewTab?: boolean;
  clickCount?: number;
}

export interface PopupTheme {
  backgroundColor?: string;
  textColor?: string;
  accentColor?: string;
  blurBackdrop?: boolean;
  showCloseButton?: boolean;
  autoPlaySlides?: boolean;
  autoPlayInterval?: number;
}

export type PopupAudienceType =
  | 'all'
  | 'guests'
  | 'authenticated'
  | 'customers'
  | 'sellers'
  | 'specific_users'
  | 'specific_roles';

export type PopupDisplayType =
  | 'modal_center'
  | 'modal_bottom'
  | 'modal_top'
  | 'fullscreen';

export type PopupFrequency =
  | 'always'
  | 'once_per_session'
  | 'once_per_day'
  | 'once_forever';

export type PopupPlatform = 'web' | 'mobile' | 'all';
export type PopupSurface = 'public_site' | 'buyer_panel' | 'seller_panel';

export interface SitePopupPayload {
  name: string;
  internalNote?: string;
  title?: string;
  content?: string;
  slides?: PopupSlide[];
  displayType?: PopupDisplayType;
  theme?: PopupTheme;
  audience: {
    type: PopupAudienceType;
    userIds?: string[];
    roleIds?: string[];
  };
  platforms?: PopupPlatform[];
  surfaces?: PopupSurface[];
  pages?: string[];
  frequency?: PopupFrequency;
  startDate?: string;
  endDate?: string;
  priority?: number;
  isActive?: boolean;
  isPinned?: boolean;
  triggerDelay?: number;
  exitIntent?: boolean;
}

export interface ListParams {
  page?: number;
  limit?: number;
  search?: string;
  isActive?: boolean;
  audienceType?: string;
  displayType?: string;
  platform?: string;
}

export const listPopups = async (params: ListParams = {}) => {
  const response = await api.get('/admin/popups', { params }) as any;
  return response;
};

export const getPopupById = async (id: string) => {
  const response = await api.get(`/admin/popups/${id}`) as any;
  return response;
};

export const createPopup = async (data: SitePopupPayload) => {
  const response = await api.post('/admin/popups', data) as any;
  return response;
};

export const updatePopup = async (id: string, data: Partial<SitePopupPayload>) => {
  const response = await api.put(`/admin/popups/${id}`, data) as any;
  return response;
};

export const deletePopup = async (id: string) => {
  const response = await api.delete(`/admin/popups/${id}`) as any;
  return response;
};

export const togglePopupActive = async (id: string, isActive: boolean) => {
  const response = await api.patch(`/admin/popups/${id}/toggle-active`, { isActive }) as any;
  return response;
};
